import  { useEffect, useState } from 'react'
import {Swiper,SwiperSlide} from 'swiper/react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import api from '../../api/api';
import { useAppDispatch } from '../../store/store';
import { setLoading } from '../../store/slice/utilSlice';
import { formatTime, getDayOfWeek } from '../../helpers/helper';
import { FiPlusCircle } from "react-icons/fi";
import { FaShoppingCart, FaSpinner } from "react-icons/fa";
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { IoIosArrowBack } from 'react-icons/io';
import parse from 'html-react-parser'
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { useCourseStore } from '../../store/useCourseStore';

type Props = {}

interface Month {
    id: string;
    name: string;
    date: Date;
    disabled?: boolean;
}

const CourseView = (props: Props) => {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    let { id } = useParams()
    const [course, setCourse] = useState<any>({
        images: [],
        name: "",
        description: "",
        course_type: 1,
        price: 0,
        branches: [],
        puchased_date: []
    })
    const { t } = useTranslation()
    const { selectedStudent, setSelectedStudent, setLastVisitedCourseId, clearLastVisitedCourse } = useCourseStore()

    useEffect(() => {
        if (!selectedStudent || Object.keys(selectedStudent).length == 0) {
            return navigate("/")
        }
        if (id) {
            setLastVisitedCourseId(id)
        }
        getCourseById()
    }, [])

    function getCourseById() {
        dispatch(setLoading(true))
        api.get(`${process.env.REACT_APP_API_BASE_URL}/course/branch/${id}?student_id=${selectedStudent?.id}&start_from=${getSixMonthsBefore()}`).then( res => {
            dispatch(setLoading(false))
            console.log("res courseview", res.data.data)
            setCourse(res.data.data)
        }).catch( err => {
            dispatch(setLoading(false))
            console.log("err", err)
        })
    }
    
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const [selectedMonths, setSelectedMonths] = useState<Month[]>([])

    function handleAddToCart() {
        if (selectedMonths.length === 0) return toast.warn("Please select period");
    
        // Check if selectedMonths length is a valid multiple of course.period
        if (selectedMonths.length % course.period !== 0) return toast.warn(`Please select the correct payment month`);

        // Convert selectedMonths into the desired format
        const formattedMonths = selectedMonths.map((month: Month) => {
            const [year, monthName] = month.name.split(" ")
            const date = moment(`${monthName} ${year}`, "MMMM YYYY")
            if (!date.isValid()) {
                console.error("Invalid date:", month.name)
                return null
            }
            return date.format("MM/YYYY")
        }).filter(date => date !== null)
    
        if (formattedMonths.length === 0) {
            return toast.warn("Invalid date format in selected months")
        }
    
        dispatch(setLoading(true))
        api.post(`${process.env.PUBLIC_URL}/cart/add`, {
            "student": selectedStudent?.id,
            "type": "course",
            "id": id,
            "selected_date": formattedMonths
        }).then(res => {
            dispatch(setLoading(false))
            toast.success(t("course_view.added_to_cart"))
            console.log("res", res)
        }).catch(err =>{
            dispatch(setLoading(false))
            if (err.response && err.response.data && err.response.data.errors && err.response.data.errors.message.length > 0) {
                for (let msg in err.response.data.errors.message) {
                    toast.error(err.response.data.errors.message[msg])
                }
            }
        })
    }

    function handleAddToCartItem(item_id: number) {
        dispatch(setLoading(true))
        api.post(`${process.env.PUBLIC_URL}/cart/add`, {
            "student": selectedStudent?.id,
            "type": "item",
            "id": item_id,
            "quantity": 1,
            "course_branch_id": id
        }).then(res => {
            dispatch(setLoading(false))
            toast.success(t("course_view.added_to_cart"))
            console.log("res", res)
        }).catch(err =>{
            dispatch(setLoading(false))
            toast.error(t("server_error"))
            console.log("err", err)
        })
    }

    useEffect(() => {
        // Attach event listener to close dropdown on outside click
        document.addEventListener("click", handleClickOutside)
        return () => {
            document.removeEventListener("click", handleClickOutside)
        };
    }, [])

    const handleClickOutside = (event:any) => {
        // Close the dropdown if clicked outside
        if (!event.target.closest(".dropdown-container")) {
            setIsOpen(false)
        }
    }


    const toggleDropdown = (): void => {
        setIsOpen(!isOpen);
    };

    const getMonths = (): Month[] => {
        const months: Month[] = []
        const startDate = new Date()
        startDate.setDate(1) // Start from the first day of the current month
        startDate.setMonth(startDate.getMonth() - 6) // Move 6 months back
    
        for (let i = 0; i < 24; i++) { // Total 24 months (6 past + current + 17 future)
            const month = new Date(startDate)
            month.setMonth(startDate.getMonth() + i)

            const year = month.getFullYear()
            const monthNumber = String(month.getMonth() + 1).padStart(2, "0")

            months.push({
                id: `${year}-${monthNumber}`,
                name: month.toLocaleString("en-US", { month: "short", year: "numeric" }),
                date: month,
                disabled: (course.purchased_date && course.purchased_date.includes(`${year}-${monthNumber}`)) ? true : false
            })
        }
    
        return months
    }

    const months: Month[] = getMonths()

    const handleSelectMonth = (selectedMonth: Month): void => {
        // if (selectedMonth.disabled) return;
        const index = months.findIndex((m) => m.id === selectedMonth.id)
    
        const foundItem = selectedMonths.find(item => item.id === months[index].id);
        if (foundItem) {
            // remove
            const updatedSelectedMonths = selectedMonths.filter(item => item.id != selectedMonth.id)
            setSelectedMonths(updatedSelectedMonths)
        } else {
            // add
            const newSelectedMonths: Month[] = [];
            const month = months[index]
            newSelectedMonths.push({
                id: month.id,
                name: month.name,
                date: month.date,
                disabled: false, // Adjust if needed
            })

            setSelectedMonths([...selectedMonths, ...newSelectedMonths])
        }
    };

    const isChecked = (month: Month): boolean => {
        return selectedMonths.some((m) => m.id === month.id)
    }

    const getSelectedRangeLabel = (): string => {
        if (selectedMonths.length === 0) return "Select a Month"
        // const startMonth = selectedMonths[0].name
        // const endMonth = selectedMonths[selectedMonths.length - 1].name
        // const period = course.period || 1
        // if (period === 1) {
        //     return `${startMonth}`
        // }
        // return `${startMonth} - ${endMonth}`
        const items = selectedMonths
        
        items.sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime());
        
        let returnString = ""
        for (let selected of items) {
            returnString += selected.name + ", "
        }

        return returnString
    }

    const [isExpanded, setIsExpanded] = useState(false);

    const toggleExpanded = () => {
        setIsExpanded(!isExpanded);
    };
  
    const getShortenedDescription = (html:any) => {
        if (html == "" || html == null) return ""
        
        const tempElement = document.createElement('div');
        tempElement.innerHTML = html;
      
        // Replace <p> and <br> with newline characters
        const textContent = tempElement.innerHTML
          .replace(/<\/p>|<br\s*\/?>/gi, '\n') // Add line breaks
          .replace(/<[^>]+>/g, '') // Remove other HTML tags
          .trim();
      
        // Truncate the text
        const shortenedText = textContent.slice(0, 40) + (textContent.length > 40 ? '...' : '');
      
        // Replace newlines with <br> before parsing
        return parse(shortenedText.replace(/\n/g, '<br />'));
    }
      

    const navigateBack = () => {
        // if (window.history?.length && window.history.length > 1) {
        //     navigate(-1)
        // } else {
            clearLastVisitedCourse() // Clear state if the user presses Back
            navigate('/', { replace: true })
        // }
    }

    function getSixMonthsBefore(): string {
        // For matching with purchased_date / waive course month
        const now = new Date()
        now.setMonth(now.getMonth() - 6)
      
        const year = now.getFullYear()
        const month = String(now.getMonth() + 1).padStart(2, "0") // Ensure two-digit month format
        // YYYY-MM
        return `${year}-${month}`
    }
      
  
    return (
        <>
        <div className="pb-16 px-2">
            <div className='mb-3 grid grid-cols-6 mx-1'>
                <div className='self-center'><IoIosArrowBack size={24} color='#000' onClick={()=>navigateBack()}/></div>
                <div className='text-center col-span-4 text-lg font-medium'>{course.course_name}</div>
                <div></div>
            </div>
            <div className="mb-10">
                <Swiper slidesPerView={1} spaceBetween={0}>
                {course.images.map((single: any, key: number) => (
                    <SwiperSlide key={key}>
                    <div className="flex justify-center items-center h-96 w-full bg-white">
                        <img src={single} alt="" className="object-cover h-full" />
                    </div>
                    </SwiperSlide>
                ))}
                </Swiper>
            </div>

            <div className="product-content-header-area border-bottom--thick pb-2">
                <div className="container">
                <div className="row mb-4">
                    <div className="col-12">
                    <div className="grid grid-cols-6 gap-1">
                        <div className="col-span-4">
                        <div className='text-lg font-medium'>{course.course_name}</div>
                        <div className='text-md mt-1 font-normal'>{course.branch_name || "-"}</div>
                        </div>
                        <div className="text-lg font-medium col-span-2 text-end">{`RM ${course.price}`}</div>
                    </div>
                    </div>
                </div>
                <div className="row mb-4">
                    <div className="col-12">
                    {isExpanded ? parse(course.description) : getShortenedDescription(course.description)}
                    </div>
                    <button className="text-theme hover:text-theme focus:outline-none mt-2" onClick={toggleExpanded} >
                    {isExpanded ? t('course_view.view_less') : t('course_view.view_more')}
                    </button>
                </div>
                <div className="row mb-4">
                    <div className="col-12">
                    <div><span className='text-md font-medium'>{t('course_view.website')}: </span><a href={course.website_link || "#"} style={{ color: "revert", textDecoration: "revert" }}>{course.website_link}</a></div>
                    <div><span className='text-md font-medium'>{t('course_view.youtube')}: </span><a href={course.youtube_link || "#"} style={{ color: "revert", textDecoration: "revert" }}>{course.youtube_link}</a></div>
                    </div>
                </div>
                </div>
            </div>

            <div className="product-content-description border-bottom--thick space-pt--25 pb-2">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="mb-1 text-lg font-medium">{t('course_view.schedule')}</div>
                                <div style={{marginBottom: "5px"}}>
                                    {course.schedules && course.schedules.map( (sch:any, index:number) => (
                                    <div key={index}>{sch.day.label}, {formatTime(sch.start_time)} - {formatTime(sch.end_time)}</div>
                                    ))}
                                </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="product-content-description border-bottom--thick space-pt--25 pb-2">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="mb-1 text-lg font-medium">{t('course_view.class_venue')}</div>
                            <div style={{marginBottom: "3px"}}>{course.venue}</div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="pb-2 pt-6">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                        <div className='mb-1 text-md font-medium'>{t('course_view.paying_for')}: {course.period} {t('course_view.months')}</div>
                            <div className="relative dropdown-container">
                                <button className="text-lg font-light rounded-md px-2 py-2 bg-white shadow-course-card flex items-center w-full" onClick={toggleDropdown} >
                                    <span>{getSelectedRangeLabel()}</span>
                                </button>
                                {isOpen && (
                                    <div className="mt-2 bg-white shadow-course-card rounded-md w-full z-10" style={{ maxHeight: "28rem", overflowY: "auto" }} >
                                        {months.map((month) => (
                                            <div key={month.id} className={`flex items-center px-4 py-2 ${month.disabled ? "opacity-50 cursor-not-allowed line-through" : "hover:bg-gray-100 cursor-pointer"}`} onClick={() => {
                                                if (!month.disabled) {
                                                    handleSelectMonth(month)
                                                }
                                            }} >
                                                <input type="checkbox" className="mr-2" checked={isChecked(month)} readOnly disabled={month.disabled} />
                                                    <span className='text-lg'>{month.name} {month.disabled && "(Waived)"}</span>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="flex justify-center mt-8">
                <button onClick={() => { handleAddToCart() }} className="bg-theme w-4/6 flex gap-3 text-white justify-center text-center mb-3 h-12 py-2 px-4 font-normal text-base items-center rounded-full cursor-pointer hover:bg-gray-400" >
                <FaShoppingCart size={18} />
                    {t('course_view.add_to_cart')}
                </button>
            </div>

            <div className='grid grid-cols-2 gap-2 px-2 mt-8'>
                {course.items && course.items.map( (item:any, index:number) => (
                    <div className="p-2 px-2.5 rounded-xl mb-14 shadow-course-card" key={index}>
                        <Link to={`/item/${item.id}?course_branch_id=${id}`} className='text-base font-medium mb-2'>{item.name}</Link>
                        <Link to={`/item/${item.id}?course_branch_id=${id}`} className='w-full'>
                            <div className="py-2 self-center justify-items-center">
                                {item.images && item.images.length > 0 ? (
                                    <img style={{height: "10rem"}} className="rounded-2xl" alt="" src={item.images[0]}/>
                                ):(
                                    <img style={{height: "10rem"}} className="rounded-2xl" alt="" src={"/assets/img/products/product1.png" }/>
                                )}
                            </div>
                        </Link>
                        <Link to={`/item/${item.id}?course_branch_id=${id}`} className="flex justify-between">
                            <div className='text-base font-medium'>RM {item.price}</div>
                            <div className='text-sm font-normal text-gray-400 self-end'>{t('course_view.stock')}: {item.stock}</div>
                        </Link>
                        <div className="flex justify-center">
                            <div onClick={() => { handleAddToCartItem(item.id) }} className="justify-content-center bg-theme w-full flex gap-2 text-white text-center mt-3 py-2 px-1 items-center rounded-full cursor-pointer hover:bg-gray-400" >
                                <FiPlusCircle size={18} />
                                <div>{t('course_view.add_to_cart')}</div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

        </div>
    </>
    )
}

export default CourseView